import { safeJoin } from '@dte/otw-utils-core/src/strings/safeJoin';
import { titleCaseValue } from '@dte/otw-utils-core/src/strings/titleCaseValue';

import type { PremiseDataAddress } from '../../../../interfaces/containers/premises/PremiseData';

export function getAddressLine2(address: PremiseDataAddress | undefined): string | undefined {
	const parts = [address?.secondaryCode, address?.secondaryValue];
	const joined = safeJoin(parts);
	return titleCaseValue(joined);
}
